/**
 * 菜单与权限的映射关系
 *
 * 规则：
 * - 如果用户拥有数组中的任意一个权限，菜单即可见
 * - 如果菜单未配置权限要求，默认隐藏（由 menu-filter 控制）
 * - 父菜单隐藏时，子菜单也会隐藏
 */

export const MENU_PERMISSIONS: Record<string, string[]> = {
  // 商业项目管理
  projects: [
    'business_project:view_all',
    'business_project:view_department',
    'business_project:view_own',
  ],
  'projects/list': [
    'business_project:view_all',
    'business_project:view_department',
    'business_project:view_own',
  ],
  'projects-create': [
    'business_project:create_all',
    'business_project:create_department',
    'business_project:create_own',
  ],

  // 框架协议
  frameworks: [
    'business_project:view_all',
    'business_project:view_department',
    'business_project:view_own',
  ],
  'frameworks/list': [
    'business_project:view_all',
    'business_project:view_department',
    'business_project:view_own',
  ],

  // 售前支持
  presales: [
    'presale:view_all',
    'presale:view_department',
    'presale:view_own',
  ],
  'presales/list': [
    'presale:view_all',
    'presale:view_department',
    'presale:view_own',
  ],
  'presales-create': [
    'presale:create_all',
    'presale:create_department',
    'presale:create_own',
  ],

  // 专业贡献
  contributions: [
    'contribution:view_all',
    'contribution:view_department',
    'contribution:view_own',
  ],
  'contributions/list': [
    'contribution:view_all',
    'contribution:view_department',
    'contribution:view_own',
  ],
  'contributions-create': [
    'contribution:create_all',
    'contribution:create_department',
    'contribution:create_own',
  ],

  // 任务和工时管理（对所有人可见，移除权限要求）
  // tasks: [],

  // 待办中心（审批管理）（对所有人可见，移除权限要求）
  // 'approval-center': [],

  // 业绩管理
  'performance/list': [
    'performance:view_all',
    'performance:view_department',
    'performance:view_own',
  ],
  'performance-create': [
    'performance:create_all',
    'performance:create_department',
    'performance:create_own',
  ],

  // 成本管理（一级菜单）
  costs: [
    'cost:view_labor_all',
    'cost:view_labor_department',
    'cost:view_travel_all',
    'cost:view_travel_department',
    'cost:view_outsource_all',
    'cost:view_outsource_department',
  ],
  // 成本管理二级菜单
  'costs/labor/list': [
    'cost:view_labor_all',
    'cost:view_labor_department',
  ],
  'costs/travel/list': [
    'cost:view_travel_all',
    'cost:view_travel_department',
  ],
  'costs/outsource/list': [
    'cost:view_outsource_all',
    'cost:view_outsource_department',
  ],

  // 报表中心
  reports: [
    'report:view_signed_performance',
    'report:view_completed_performance',
    'report:view_acceptance_performance',
    'report:view_hours_statistics',
  ],
  'reports/signed-performance': ['report:view_signed_performance'],
  'reports/completed-performance': ['report:view_completed_performance'],
  'reports/acceptance-performance': ['report:view_acceptance_performance'],
  'reports/hours-report': ['report:view_hours_statistics'],
  'reports/hours-report/drilldown': ['report:view_hours_statistics'],
  'reports/report2': ['report:view_signed_performance'],

  // 系统设置（所有子菜单统一使用 setting:view）
  settings: ['setting:view'],
  'settings/users': ['setting:view'],
  'settings/project-permissions': ['setting:view'],
  'settings/system-permissions': ['setting:view'],
  'settings/approval': ['setting:view'],
  'settings/cost': ['setting:view'],
  'settings/other': ['setting:view'],
};

/**
 * 不需要权限的菜单（所有人可见）
 */
export const PUBLIC_MENU_KEYS = [
  'dashboard',
  'dashboard/workplace',
  'profile',

  // 任务与工时（当前按公开菜单处理）
  'tasks',
  'tasks/index',
  'tasks/calendar',

  // 待办中心（当前按公开菜单处理）
  'approval-center',

  // 报表中心已接入权限控制
];

/**
 * 角色菜单屏蔽配置（用于未接入权限控制的历史菜单兜底）
 */
export const ROLE_BLOCKED_MENU_KEYS: Record<string, string[]> = {
  hrbp: ['tasks', 'tasks/index', 'tasks/calendar'],
};
